const KM_PER_MILE = 1.609
const MILES_PER_KM = 0.621371;

export const convertKmToMiles = (kmValue: number) => kmValue * MILES_PER_KM

export const convertMilesToKm = (milesValue: number) => milesValue * KM_PER_MILE
